<div class="modal-header d-flex align-items-center justify-content-start header flex-wrap flex-md-nowrap">
  <img class="pr-image"
      [src]="productImg"
      alt="product-logo">
  <div class="d-flex flex-column align-items-start">
      <div class="modal-title mb-2">{{ productName }}</div>
      <div>{{ productShortDescription }}</div>
  </div>
</div>